import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import './index.css';
import App from './App';
import { BulkUpdateProvider } from './context/BulkUpdateContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <BulkUpdateProvider>
        <App />
      </BulkUpdateProvider>
    </BrowserRouter>
  </React.StrictMode>
);
